import { render, staticRenderFns } from "./TrackingStagesLotes.vue?vue&type=template&id=2c7f4ef2"
import script from "./TrackingStagesLotes.vue?vue&type=script&lang=js"
export * from "./TrackingStagesLotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports